// @flow

export const FORMIK_EMPTY_VALUE = ''
